<template>
  <div class="">
    <MacrosSpecEditor v-if="specAvailable" :spec="macrosSpec" @save="onMacrosSave"></MacrosSpecEditor>
  </div>
</template>
<script setup>
  import { useRoute, useRouter } from 'vue-router';
  import { useToast } from 'vue-toastification';
  import { onMounted, ref, computed } from 'vue';
  import MacrosSpecEditor from '@/components/Macros/Edit/MacrosSpecEditor.vue';
  import { useMacrosStore } from '@/store/MacrosStore';

  const route = useRoute();
  const router = useRouter();

  const macrosStore = useMacrosStore();

  // Not reactive - no need. Keeps a latest saved macros spec.
  let macrosSpec = null;
  const specAvailable = ref(false);

  const toast = useToast();

  function onMacrosSave(updatedMacrosSpec, showToast = true) {
    // Save the latest value
    macrosSpec = updatedMacrosSpec;
    macrosStore.setMacros(macrosSpec).then((saveResult) => {
      if (showToast) {
        if (saveResult) {
          toast.success('Macros saved successfully');
        } else {
          toast.error(`Error saving macros`);
        }
      }
    });
  }

  onMounted(async () => {
    let id = route.params?.id || null;
    if (!id) {
      console.log(`ERROR: macros ID must be specified`);
      toast.error(`macros ID must be specified`);
      return;
    }

    macrosSpec = await macrosStore.loadMacros(id);
    if (macrosSpec) {
      specAvailable.value = true;
    }
  });
</script>
